import ConfirmCancelButtons from '@/components/molecules/ConfirmationModal/ConfirmCancelButtons';
import ModalContainer from '@/components/molecules/ModalContainer/ModalContainer';
import { HStack, Text, Textarea, VStack } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

// Matches CONTENT_REMOVAL_REASON_MAX_LENGTH on the backend.
const REMOVAL_REASON_MAX_LENGTH = 500;

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: (removalReason: string) => void;
}

const RemoveContentModal = ({ isOpen, isLoading, onCancel, onConfirm }: Props) => {
  const [removalReason, setRemovalReason] = useState('');

  // Reset the field whenever the modal is reopened.
  useEffect(() => {
    if (isOpen) {
      setRemovalReason('');
    }
  }, [isOpen]);

  const trimmedReason = removalReason.trim();

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={onCancel}
      title="Remove Content"
      footerContent={
        <ConfirmCancelButtons
          confirmButtonText="Remove"
          confirmButtonColor="extra.red"
          confirmButtonDisabled={!trimmedReason}
          confirmLoading={isLoading}
          onCancel={onCancel}
          onConfirm={() => onConfirm(trimmedReason)}
          marginBottom="0"
        />
      }
    >
      <VStack align="stretch" gap="10px" marginY="20px">
        <Text fontSize="16px">
          This hides the content from the feed. The reason is recorded in the audit log; the
          content can be restored later.
        </Text>
        <Textarea
          backgroundColor="white"
          minHeight="120px"
          maxLength={REMOVAL_REASON_MAX_LENGTH}
          placeholder="Reason for removal"
          value={removalReason}
          onChange={(event) => setRemovalReason(event.target.value)}
        />
        <HStack justify="flex-end">
          <Text fontSize="12px" color="text.mediumGray">
            {removalReason.length}/{REMOVAL_REASON_MAX_LENGTH}
          </Text>
        </HStack>
      </VStack>
    </ModalContainer>
  );
};

export default RemoveContentModal;
